import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarReadingPaneUtils"*/ './lazyIndex')
);

// Lazy-load actions
export const lazyInitializeProposeNewTimeForDeeplink = new LazyAction(
    lazyModule,
    m => m.initializeProposeNewTimeForDeeplink
);
export const lazyOpenNotesEditorForProposeNewTime = new LazyAction(
    lazyModule,
    m => m.openNotesEditorForProposeNewTime
);
export const lazyInitializeForward = new LazyAction(lazyModule, m => m.initializeForward);
